<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#FFF" active-text-color="#fff">
    <el-button class="buttonimg">
      <!-- <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)"> -->
      <i :class="collapsed?'el-icon-s-fold':'el-icon-s-unfold'" @click="toggle(collapsed)"></i>
    </el-button>
   {{routeName}}
    <el-submenu index="2" class="submenu">
      <template slot="title">{{account}}</template>
      <el-menu-item @click="exit">退出登录</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import {getStore, removeStore}  from '../utils/util';
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      account: ''
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.account = getStore("account")
  },
  // vue计算属性
  computed: {
    routeName: function () {
      // 获取当前路由
      return this.$route.name
    }
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        setTimeout(() => {
          removeStore("user");
          this.$router.push({ path: '/login' });
          this.$message({
            type: 'success',
            message: '已退出登录!'
          })
        }, 300)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.el-icon-s-fold,.el-icon-s-unfold {
  font-size: 24px;
  color: #000;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue